import { Navigate } from 'react-router-dom';

export const MyProfile = () => {
  return <Navigate to='/my-profile/my-activity' replace />;
};
